import { Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { QueryService } from '../comun/services/query.service';
import { GlobalConstants } from '../global-constants';

@Component({
  selector: 'app-amigos',
  templateUrl: './amigos.component.html',
  styleUrls: ['./amigos.component.css']
})
export class AmigosComponent implements OnInit, OnChanges {
  @Input() userid: string | number = '';
  @ViewChild('carrusel') carrusel?: ElementRef<HTMLElement>;
  puedeAnterior = false;
  puedeSiguiente = false;
  global = GlobalConstants;
  rol_social = false;
  amigos: any[] = [];
  cargando = true;
  error = false;
  private inicializado = false;
  private solicitud = 0;

  constructor(private query: QueryService, private http: HttpClient) {}

  ngOnInit(): void {
    this.inicializado = true;
    this.getRolPerfil();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.inicializado && changes['userid'] && !changes['userid'].firstChange) {
      this.getAmigos();
    }
  }

  getRolPerfil(): void {
    this.cargando = true;
    this.error = false;
    this.query.query('misdatos', 'ESROLSOCIAL', { ID: 0 }).subscribe({
      next: (resultado: any) => {
        this.rol_social = resultado === true || resultado === 1 || resultado === '1';
        if (this.rol_social) this.getAmigos();
        else this.cargando = false;
      },
      error: () => { this.cargando = false; this.error = true; }
    });
  }

  getAmigos(): void {
    const actual = ++this.solicitud;
    this.cargando = true;
    this.error = false;
    this.query.query('seguir', 'GET', { ID: this.userid, se_estado: 'activo' }).subscribe({
      next: (resultado: any) => {
        if (actual !== this.solicitud) return;
        this.amigos = Array.isArray(resultado?.registros) ? resultado.registros : [];
        this.ordenarAmigos();
        this.cargando = false;
        this.puedeAnterior = false;
        this.puedeSiguiente = this.amigos.length > 3;
        this.amigos.forEach(amigo => this.checkOnline(amigo, actual));
      },
      error: () => {
        if (actual !== this.solicitud) return;
        this.amigos = [];
        this.cargando = false;
        this.error = true;
      }
    });
  }

  checkOnline(amigo: any, solicitudActual: number = this.solicitud): void {
    const id = Number(amigo?.ID);
    if (!Number.isInteger(id) || id <= 0) return;
    this.http.get<any>(`${GlobalConstants.urlServer}wp-json/custom/v1/user-online/${id}`)
      .subscribe({
        next: (res) => {
          if (solicitudActual !== this.solicitud) return;
          amigo.online = !!res?.online;
          // Evitamos reordenar mientras el usuario navega por el carrusel.
        },
        error: () => { /* Estado desconocido: no interrumpir el listado. */ }
      });
  }

  ordenarAmigos(): void {
    this.amigos.sort((a: any, b: any) => {
      if (!!a.online !== !!b.online) return a.online ? -1 : 1;
      return String(a.first_name || '').localeCompare(String(b.first_name || ''), 'es');
    });
  }

  navegar(direccion: -1 | 1): void {
    const elemento = this.carrusel?.nativeElement;
    if (!elemento) return;
    const primero = elemento.querySelector<HTMLElement>('.iguau-amigos__item');
    if (!primero) return;
    const estilo = getComputedStyle(elemento);
    const separacion = parseFloat(estilo.columnGap || estilo.gap || '0') || 0;
    // Cada pulsación avanza o retrocede exactamente tres tarjetas.
    const paso = (primero.getBoundingClientRect().width + separacion) * 3;
    elemento.scrollBy({ left: direccion * paso, behavior: 'smooth' });
  }

  actualizarNavegacion(): void {
    const elemento = this.carrusel?.nativeElement;
    if (!elemento) return;
    const maximo = Math.max(0, elemento.scrollWidth - elemento.clientWidth);
    this.puedeAnterior = elemento.scrollLeft > 2;
    this.puedeSiguiente = elemento.scrollLeft < maximo - 2;
  }

  @HostListener('window:resize')
  alCambiarTamano(): void { this.actualizarNavegacion(); }

  trackByAmigo(_index: number, amigo: any): string | number {
    return amigo.ID ?? amigo.slug ?? _index;
  }

  enlacePerfil(amigo: any): string {
    const slug = String(amigo?.slug || '').trim();
    return slug ? `${GlobalConstants.urlServer}perfil/${encodeURIComponent(slug)}/` : '#';
  }

  fotoMascota(amigo: any): string {
    return amigo?.foto_mascota_thumb || amigo?.mascota?.foto_principal_thumb ||
      `${GlobalConstants.urlServer}img/default-user.png`;
  }

  fotoUsuario(amigo: any): string {
    return amigo?.foto?.foto_principal_thumb || amigo?.foto_principal_thumb ||
      `${GlobalConstants.urlServer}img/default-user.png`;
  }

  nombreMascota(amigo: any): string {
    return String(amigo?.mascota?.ma_nombre || '').trim().split(/\s+/)[0] || 'Mascota';
  }

  nombreUsuario(amigo: any): string {
    return String(amigo?.first_name || '').trim().split(/\s+/)[0] || 'Usuario';
  }

  irPerfil(amigo: any): void {
    const enlace = this.enlacePerfil(amigo);
    if (enlace !== '#') window.location.href = enlace;
  }

  goPerfil(amigo: any): void { this.irPerfil(amigo); }
}
